import { pickApi } from "./pick";

export const {
  useLazyGetPickQuery,
  useGetPicksQuery,
  useCaptureWeightMutation,
  useRejectWeightMutation,
  useVerifyPickMutation,
  useCompletePickMutation,
  useSplitPickMutation
} = pickApi;
